import type { ComputedRef } from 'vue'

import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

import type { SupportContactModel } from '@/domains/tenant/types/SupportContactModel.types'

/**
 * The single access point for who this tenant rings.
 *
 * Reads the `supportContact` shared Inertia prop, which every admin page carries,
 * and returns null on the landlord domain — there is no tenant there to resolve a
 * desk against. The dashboard card and the Help control in the shell both read
 * this; neither reads `usePage().props.supportContact` directly. The prop is cast
 * because Inertia's `usePage()` does not resolve the global PageProps
 * augmentation here (same pattern as `useTenantIsExo`).
 */
const useSupportContact = (): ComputedRef<SupportContactModel | null> => {
  const page = usePage()

  return computed(() => (page.props.supportContact as SupportContactModel | undefined) ?? null)
}

export { useSupportContact }
